import { Prisma } from '@prisma/client';
import { ProductInclude } from '../includes/Product';
var IncludeProduct = Prisma.validator()({
    include: ProductInclude,
});
export var LifecycleSteps;
(function (LifecycleSteps) {
    LifecycleSteps["PRODUCT_CONFIGURATION"] = "Product configuration";
    LifecycleSteps["PRODUCT_COMPOSITION"] = "Product composition";
    LifecycleSteps["PRODUCTION"] = "Production";
    LifecycleSteps["PACKAGING"] = "Packaging";
    LifecycleSteps["DISTRIBUTION_AND_STORAGE"] = "Distribution & storage";
    LifecycleSteps["USAGE"] = "Usage";
    LifecycleSteps["END_OF_LIFE"] = "End-of-life";
    LifecycleSteps["SALES"] = "Sales";
})(LifecycleSteps || (LifecycleSteps = {}));
//# sourceMappingURL=Product.js.map